module.exports = __webpack_public_path__ + "static/img/clothes.64941ead.png";